import React, { useEffect, useState } from "react";
import "./companyProfileEditPopup.scss";
import {
  deleteicon,
  deleteiconcircle,
  downloadFileIcon,
  downloadIcon,
  editIconBlue,
  eyeClose,
  eyeOpen,
  lockIcon,
  modalCloseIcon,
  pdfIcon,
  pdfImagePreview,
  trashIconCircleOrange,
  uploadIcon,
  uploadIconBlack,
  eyeIcon,
  trashIconCircleOrangeDark,
  eyeCloseDark,
  eyeOpenDark,
} from "../../../../../images";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import config from "../../../../../config/config";
import BusinessFileUpload from "../../../../../components/BusinessFileUpload/BusinessFileUpload";
import style from "../../../../../pages/FormFiveLightTheme/Form/formfivelighttheme.module.scss";
import DeleteConfirmPopup from "../DeleteConfirmPopup/DeleteConfirmPopup";
import DeleteConfirmProfilePopup from "../DeleteConfirmProfileUploads/DeleteConfirmProfilePopup";
import http from "../../../../../helpers/http";
import { useBusinessContext } from "../../../../../context/BusinessAccount/BusinessAccountState";
import BusinessFileUploadEdit from "../../../../../components/BusinessFileUploadEdit/BusinessFileUploadEdit";
import { toast } from "react-toastify";
import ToastMsg from "../../../../../components/ToastMsg/ToastMsg";
import helper from "../../../../../helpers/helper";
import { useWindowSize } from "react-use";
import targetAttributesFile from "../../../../../config/target_attributes.json";
import HideUnhideProfilePopup from "../HideUnhidePopup/HideUnhidePopup";
import useTheme from "../../../../../components/useTheme/useTheme";

const CompanyProfileEditPopup = (props) => {
  const { theme } = useTheme();
  const { width } = useWindowSize();
  const [upload, setUpload] = useState(false);
  const objectUrl = config.aws_object_url + "business/";
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showHiddenPopup, setShowHiddenPopup] = useState(false);
  // const [pdfImage, setPdfImage] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState();
  const handleShowDeletePopupOpen = (item, prefixName) => {
    const updatedFile = { ...item, prefixName };
    setSelectedDoc(updatedFile);
    setShowDeletePopup(true);
  };
  const handleShowDeletePopupClose = () => setShowDeletePopup(false);
  const handleShowHiddenPopupOpen = (item, prefixName) => {
    const updatedFile = { ...item, prefixName };
    setSelectedDoc(updatedFile);
    setShowHiddenPopup(true);
  };
  const handleShowHiddenPopupClose = () => setShowHiddenPopup(false);
  const galleryTitles = [
    { key: "project_renders_media", title: "Project Photos & Renders" },
    { key: "completed_products_media", title: "Products | Materials" },
    { key: "sites_inprogress_media", title: "Sites In Progress" },
    { key: "others_media", title: "Others" },
  ];

  const {
    show,
    onHide,
    handleClose,
    categoryData,
    editIcon = false,
    isActive = 0,
    isSubtabActive = 0,
    updateCompanyProfileData,
  } = props;
  const BusinessContext = useBusinessContext();
  const TOTAL_STORAGE =
    BusinessContext?.data?.subscription?.plan?.features?.imagesLimit || 200;

  const totalImages = galleryTitles.reduce((sum, { key }) => {
    return sum + (BusinessContext?.data[key]?.length || 0);
  }, 0);

  const isDeleteDisabled = totalImages >= TOTAL_STORAGE;

  const handleDeleteDocument = async (documentId) => {
    if (isDeleteDisabled) {
      // toast(
      //   <ToastMsg
      //     message={`Cannot delete documents. Storage limit of ${TOTAL_STORAGE} images reached.`}
      //     danger={true}
      //   />,
      // );
      return;
    }
    const response = await http.put(
      `${config.api_url}/business/business-details/${categoryData?.userId}/documents`,
      { documentId }
    );
    if (response?.data) {
      const updatedData = categoryData.data.filter(
        (doc) => doc._id !== documentId
      );
      categoryData.data = updatedData;
      BusinessContext.update({
        ...BusinessContext.data,
        [categoryData.category.key]: updatedData,
      });
      updateCompanyProfileData({
        ...BusinessContext.data,
        [categoryData?.category?.key]: updatedData,
      });
      toast(
        <ToastMsg message={`Document deleted successfully`} />,
        config.success_toast_config
      );

      handleShowDeletePopupClose();
    }
  };

  const handleVisibilityDocument = async (documentId) => {
    const visibility = !selectedDoc?.visibility;
    const response = await http.put(
      `${config.api_url}/business/hide-documents`,
      {
        documentId,
        visibility,
      }
    );
    if (response?.data) {
      const updatedData = categoryData.data.map((doc) =>
        doc._id === selectedDoc._id ? { ...doc, visibility: visibility } : doc
      );
      categoryData.data = updatedData;
      BusinessContext.update({
        ...BusinessContext.data,
        [categoryData.category.key]: updatedData,
      });
      updateCompanyProfileData({
        ...BusinessContext.data,
        [categoryData?.category?.key]: updatedData,
      });
      toast(
        <ToastMsg message={`Document updated successfully`} />,
        config.success_toast_config
      );

      handleShowHiddenPopupClose();
    }
  };

  const scrapeContent = async (
    images_scraping_en,
    linkedin_url,
    instagram_url,
    filesS3Urls
  ) => {
    const scrapeContentApiData = new FormData();

    const basePayload = [
      // {
      //   key: "webpage_url",
      //   value: "",
      // },
      { key: "images_bucket", value: config.aws_bucket },
      { key: "images_folder", value: "business" },
      {
        key: "images_prefix",
        value: BusinessContext?.data?.username,
      },
      {
        key: "images_max_png_size_b",
        value: 1048576,
      },
      {
        key: "images_compression",
        value: 0,
      },
      {
        key: "remove_duplicates_thr",
        value: 90,
      },
      { key: "user_id", value: BusinessContext?.data?._id },
      { key: "images_min_size_b", value: 10240 },
      {
        key: "instagram_engine",
        value: "BrightData",
      },
      {
        key: "linkedin_engine",
        value: "BrightData",
      },
      {
        key: "filtering_posts_num",
        value: 300,
      },
      {
        key: "filtering_start_date",
        value: "",
      },
      {
        key: "filtering_end_date",
        value: "",
      },
      {
        key: "max_upload_size_mb",
        value: 80,
      },
      {
        key: "attributes_file",
        value: new Blob([JSON.stringify(targetAttributesFile)], {
          type: "application/json",
        }),
      },
      {
        key: "images_scraping_en",
        value: images_scraping_en,
      },
      // {
      //   key: "linkedin_url",
      //   value: "",
      // },
      // {
      //   key: "instagram_url",
      //   value: "BusinessContext.data.instagram_handle",
      // },
    ];

    basePayload.forEach(({ key, value }) =>
      scrapeContentApiData.append(key, value)
    );
    scrapeContentApiData.append("files_s3[]", JSON.stringify(filesS3Urls));

    await http.post(
      `${config.api_url}/business/scrape_content`,
      scrapeContentApiData
    );
    toast(
      <ToastMsg message="Data sent for scrapping" />,
      config.success_toast_config
    );
  };

  const handleFileUpload = async (
    uploadedFileData,
    state,
    documentMediaType
  ) => {
    const filesS3Urls = uploadedFileData.map((it) => it?.url);
    // await scrapeContent(true, "", "", filesS3Urls);
    const updatedData = await BusinessContext.fetchData(
      BusinessContext?.data?._id
    );
    categoryData.data = updatedData[documentMediaType];
    BusinessContext.update(updatedData);
    updateCompanyProfileData(updatedData);
  };

  return (
    <>
      <DeleteConfirmProfilePopup
        show={showDeletePopup}
        handleClose={handleShowDeletePopupClose}
        selectedDoc={selectedDoc}
        onDelete={handleDeleteDocument}
      />
      <HideUnhideProfilePopup
        show={showHiddenPopup}
        handleClose={handleShowHiddenPopupClose}
        selectedDoc={selectedDoc}
        onConfirm={handleVisibilityDocument}
      />
      <Modal
        {...props}
        centered
        className={`CompanyProfile_popup_modal company_profile_edit_page zIndex_company_profile ${
          theme === "dark" && "CompanyProfile_popup_modal_edit--dark-mode"
        }`}
        backdropClassName="custom-backdrop"
        fullscreen={true}
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Header>
          <button className="custom-cancel-btn" onClick={props.handleClose}>
            <img
              src={modalCloseIcon}
              alt="close-icon"
              className="ctm_img_bussine_edit_about"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className={`comp_prof_container`}>
            <div className="CompanyProfile_popup_container">
              <div className="comp_prof_wrapper CompanyProfile_popup_wrapper">
                <div className="cta_container">
                  <h2 className="title">{categoryData?.category?.title}</h2>
                  {editIcon && (
                    <div className="cta_wrapper">
                      <img
                        src={editIconBlue}
                        alt="edit icon"
                        className="edit_icon"
                      />
                      <Link to={() => false} className="bedit_common_cta">
                        Edit
                      </Link>
                    </div>
                  )}
                </div>

                <div className="row pofile_row CompanyProfile_popup_row">
                  {categoryData?.data?.map((item, index) => (
                    <div
                      className="pofile_col CompanyProfile_popup_col"
                      key={item._id || `pdf-${index}`}
                      // style={{ opacity: item?.visibility ? 1 : 0.5 }}
                    >
                      {item?.thumbnail ? (
                        <div className="profile_box">
                          <div className="img_wrapper CompanyProfile_popup_img_wrapper CompanyProfile_popup_img_wrapper_img_prev position-relative">
                            {/* <img
                              src={downloadFileIcon}
                              alt="pdf icon"
                              className="pdf_icon"
                            /> */}
                            {item?.thumbnail ? (
                              <img
                                src={`${objectUrl}${item.thumbnail}`}
                                alt="pdf-image"
                                className="pdf_img_prev_edit"
                                style={{ opacity: item?.visibility ? 1 : 0.5 }}
                              />
                            ) : (
                              <img
                                src={downloadFileIcon}
                                alt="pdf icon"
                                className={`pdf_icon`}
                              />
                            )}
                            <img
                              src={lockIcon}
                              alt="lock"
                              className="lock_pdf_icon_modal"
                            />
                            <div className="wraper_pdf_name_tarsh">
                              <h3 className="pdf_title">
                                {/* {helper.truncateFileName(item.name)} */}
                                {`${helper.getBusinessNamePrefix(
                                  `${
                                    categoryData?.category?.image_prefix
                                  }_${String(Number(index) + 1).padStart(
                                    2,
                                    "0"
                                  )}_` + BusinessContext?.data?.business_name,
                                  item.url,
                                  width >= 1200 ? 25 : 20
                                )}`}
                              </h3>
                              <div className="icons">
                                <img
                                  // src={
                                  //   item?.visibility ? eyeOpen : eyeClose
                                  // }
                                  src={
                                    item?.visibility
                                      ? theme === "dark"
                                        ? eyeOpenDark // when visible + dark theme
                                        : eyeOpen // when visible + light theme
                                      : theme === "dark"
                                      ? eyeCloseDark // when hidden + dark theme
                                      : eyeClose // when hidden + light theme
                                  }
                                  alt="download icon"
                                  className="download_icon delete_icon_pdf del_ic_prc_img"
                                  onClick={() =>
                                    handleShowHiddenPopupOpen(
                                      item,
                                      `${
                                        categoryData?.category?.image_prefix
                                      }_${String(Number(index) + 1).padStart(
                                        2,
                                        "0"
                                      )}_${helper.getBusinessNamePrefix(
                                        BusinessContext?.data?.business_name,
                                        item.url
                                      )}`
                                    )
                                  }
                                />
                                <img
                                  src={
                                    theme === "dark"
                                      ? trashIconCircleOrangeDark
                                      : trashIconCircleOrange
                                  }
                                  alt="download icon"
                                  className="download_icon delete_icon_pdf del_ic_prc_img"
                                  onClick={
                                    isDeleteDisabled
                                      ? () => {}
                                      : () =>
                                          handleShowDeletePopupOpen(
                                            item,
                                            `${
                                              categoryData?.category
                                                ?.image_prefix
                                            }_${String(
                                              Number(index) + 1
                                            ).padStart(
                                              2,
                                              "0"
                                            )}_${helper.getBusinessNamePrefix(
                                              BusinessContext?.data
                                                ?.business_name,
                                              item.url
                                            )}`
                                          )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="profile_box">
                          <div className="img_wrapper CompanyProfile_popup_img_wrapper position-relative">
                            <img
                              src={downloadFileIcon}
                              alt="pdf icon"
                              className="pdf_icon"
                            />
                            <img
                              src={lockIcon}
                              alt="lock"
                              className="lock_pdf_icon_modal"
                            />
                            <div className="icons product_catalog_icons">
                              <img
                                // src={item?.visibility ? eyeOpen : eyeClose}
                                src={
                                  item?.visibility
                                    ? theme === "dark"
                                      ? eyeOpenDark // when visible + dark theme
                                      : eyeOpen // when visible + light theme
                                    : theme === "dark"
                                    ? eyeCloseDark // when hidden + dark theme
                                    : eyeClose // when hidden + light theme
                                }
                                alt="download icon"
                                className="download_icon delete_icon_pdf del_ic_prc_img"
                                onClick={() =>
                                  handleShowHiddenPopupOpen(
                                    item,
                                    `${
                                      categoryData?.category?.image_prefix
                                    }_${String(Number(index) + 1).padStart(
                                      2,
                                      "0"
                                    )}_${helper.getBusinessNamePrefix(
                                      BusinessContext?.data?.business_name,
                                      item.url
                                    )}`
                                  )
                                }
                              />
                              <img
                                src={
                                  theme === "dark"
                                    ? trashIconCircleOrangeDark
                                    : trashIconCircleOrange
                                }
                                alt="download icon"
                                className="download_icon delete_icon_pdf"
                                onClick={
                                  isDeleteDisabled
                                    ? () => {}
                                    : () =>
                                        handleShowDeletePopupOpen(
                                          item,
                                          `${
                                            categoryData?.category?.image_prefix
                                          }_${String(
                                            Number(index) + 1
                                          ).padStart(
                                            2,
                                            "0"
                                          )}_${helper.getBusinessNamePrefix(
                                            BusinessContext?.data
                                              ?.business_name,
                                            item.url
                                          )}`
                                        )
                                }
                              />
                            </div>
                          </div>

                          <h3 className="pdf_title">
                            {/* {helper.truncateFileName(item.name)} */}
                            {`${helper.getBusinessNamePrefix(
                              `${categoryData?.category?.image_prefix}_${String(
                                Number(index) + 1
                              ).padStart(2, "0")}_` +
                                BusinessContext?.data?.business_name,
                              item.url,
                              width >= 1200 ? 25 : 20
                            )}`}
                          </h3>
                        </div>
                      )}
                    </div>
                  ))}
                  <div
                    className="pofile_col CompanyProfile_popup_col"
                    // key={item._id || `pdf-${index}`}
                  >
                    <div className="file_upload_file_container">
                      <div className={`field_wrapper`}>
                        <div
                          className={style.customdUpload_wrapper}
                          style={{ height: "100%" }}
                        >
                          <BusinessFileUploadEdit
                            theme={theme}
                            businessContext={BusinessContext.data}
                            onFileUpload={(files, state) =>
                              handleFileUpload(
                                files,
                                state,
                                categoryData?.category?.key
                              )
                            }
                            documentMediaType={categoryData?.category?.key}
                            Upload_heading={`Upload More ${categoryData?.category?.fileUploadTitle}`}
                            uploadIcon={uploadIconBlack}
                            fileSize={
                              BusinessContext?.data?.subscription?.plan
                                ?.features?.fileSizeLimitMB || 150
                            }
                          />
                          {/* <p className={style.error}>{error}</p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>

    // <Modal
    //   show={show}
    //   onHide={onHide}
    //   centered
    //   className="CompanyProfile_popup_modal company_profile_edit_page"
    //   backdropClassName="custom-backdrop"
    //   fullscreen={true}
    // >
    //   <Modal.Header>
    //     <button className="custom-cancel-btn" onClick={handleClose}>
    //       <img
    //         src={modalCloseIcon}
    //         alt="close-icon"
    //         className="ctm_img_bussine_edit_about"
    //       />
    //     </button>
    //   </Modal.Header>

    //   <Modal.Body>
    //     <div className={`comp_prof_container`}>
    //       <div className="CompanyProfile_popup_container">
    //         <div className="comp_prof_wrapper CompanyProfile_popup_wrapper">
    //           <div className="cta_container">
    //             <h2 className="title">Firm/Company Profile</h2>
    //             {editIcon && (
    //               <div className="cta_wrapper">
    //                 <img
    //                   src={editIconBlue}
    //                   alt="edit icon"
    //                   className="edit_icon"
    //                 />
    //                 <Link to={() => false} className="bedit_common_cta">
    //                   Edit
    //                 </Link>
    //               </div>
    //             )}
    //           </div>

    //           <div className="row pofile_row CompanyProfile_popup_row">
    //             {/* {CompanyProfilePopupData?.data?.map((item, index) => ( */}
    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={downloadIcon}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={downloadIcon}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={downloadIcon}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={downloadIcon}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={downloadIcon}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={deleteiconcircle}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={deleteiconcircle}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={deleteiconcircle}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="file_upload_file_container">
    //                 <div className={`field_wrapper`}>
    //                   <div
    //                     className={style.customdUpload_wrapper}
    //                     style={{ height: "100%" }}
    //                   >
    //                     <BusinessFileUpload
    //                       businessContext={upload}
    //                       //   onFileUpload={handleFileUpload}
    //                       documentMediaType={"company_profile_media"}
    //                       formatSupport=""
    //                       fileSize=" "
    //                       fileFormat=" "
    //                       Upload_heading="Upload More Product Catalogues"
    //                       uploadIcon={uploadIconBlack}
    //                     />
    //                     {/* <p className={style.error}>{error}</p> */}
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>

    //             {/* ) */}
    //             {/* )} */}
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </Modal.Body>
    // </Modal>
  );
};

export default CompanyProfileEditPopup;
